import { CommonIcons, icons } from "../../components/common/CommonIcons";

const navConfig = [
  {
    title: 'dashboard',
    path: 'dashboard',
    icon: <CommonIcons name={icons.dashboard} />
  },
];

export default navConfig;
